import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css, CSSProperties} from 'styled-components'

export const StyledAgendaAppointmentStatus = styled(Flexbox)<{$color: CSSProperties['color']}>(
    ({theme: {typography}, $color}) => css`
        ${typography.textXs};
        color: ${$color};
        text-transform: uppercase;
        font-weight: 500;
    `
)
